import React, { FC, useCallback, useMemo, useRef } from 'react'
import { Flex, useRadio } from '@chakra-ui/react'
import { Box, Text, Image, Center } from '../index'
import { RadioButtonProps } from './interfaces'
import { RadioButton } from './radio-button'
import { provinceFlagImageMap } from '../../state/interfaces'

export const SmallPillRadioButtonImage: FC<RadioButtonProps> = (props) => {
  const { getInputProps, getRadioProps } = useRadio({ ...props, value: props.value?.toString() })
  const image = useMemo(() => (props.image ? provinceFlagImageMap[props.image] : ''), [props])
  const inputRef = useRef<HTMLInputElement>(null)

  const handleFocus = () => {
    if (inputRef.current) {
      inputRef.current.focus()
    }
  }

  const hasInitials = Boolean(props.initials)
  const handleClick = useCallback((event: React.MouseEvent) => {
    event.stopPropagation()
  }, [])

  return (
    <>
      {hasInitials ? (
        <Flex as="label" cursor="pointer" data-testid={`pill-${props.value}`} display="flex">
          <Center
            {...getRadioProps()}
            margin={2}
            padding={2}
            border="3px solid #D8D8D8"
            borderRadius="lg"
            backgroundImage={'white'}
            _hover={{
              borderColor: 'brand',
              boxShadow: '0 0 0 2px #5bce4c',
            }}
            _checked={{
              borderColor: 'brand',
            }}
            _focus={{
              borderColor: 'brand',
              boxShadow: '0 0 0 2px #5bce4c',
            }}
            tabIndex={0}
            onFocus={handleFocus}
            onClick={(event) => handleClick(event)}
          >
            <RadioButton {...getInputProps()} ref={inputRef} />
            <Box
              width={['80px', '115px']}
              minHeight={['90px', '140px']}
              borderRadius="lg"
              display="flex"
              flexDirection="column"
              alignItems="center"
              textAlign="center"
            >
              <div style={{ flex: '60%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Image
                  src={image}
                  alt={`${props.value}`}
                  title={`${props.value}`}
                  aria-label={`button-${props.label}`}
                  width="75%"
                  height="75%"
                  border="black"
                  borderRadius="md"
                  objectPosition="center"
                />
              </div>
              <div style={{ flex: '40%', display: 'flex' }}>
                <Text fontSize={['9px', '14px']} fontWeight="bold">
                  {props.initials}
                </Text>
              </div>
            </Box>
          </Center>
        </Flex>
      ) : (
        <Flex as="label" cursor="pointer" data-testid={`pill-${props.value}`} display="flex">
          <Center
            {...getRadioProps()}
            width="100%"
            maxWidth={105}
            margin={2}
            padding={2}
            border="1px solid #fff"
            borderRadius="lg"
            boxShadow="md"
            backgroundImage={'white'}
            _hover={{
              borderColor: 'brand',
              boxShadow: '0 0 0 2px #5bce4c',
            }}
            _checked={{
              borderColor: 'brand',
            }}
            _focus={{
              borderColor: 'brand',
              boxShadow: '0 0 0 2px #5bce4c',
            }}
            tabIndex={0}
            onFocus={handleFocus}
            onClick={(event) => handleClick(event)}
          >
            <RadioButton {...getInputProps()} ref={inputRef} />
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              width={['60px', '90px', '120px']}
              height={['40px', '60px', '80px']}
              borderRadius="100%"
            >
              <Image
                src={image}
                alt={`${props.value}`}
                title={`${props.value}`}
                aria-label={`button-${props.label}`}
                width={['30px', '45px', '90px']}
                height={['20px', '30px', '60px']}
                border="black"
                borderRadius="md"
                objectFit="contain"
                objectPosition="center"
              />
              <Text fontSize="sx" fontWeight="bold">
                {props.label}
              </Text>
            </Box>
          </Center>
        </Flex>
      )}
    </>
  )
}
